export default "__VITE_ASSET__DzdvE20F__"